import { SxProps, Theme } from '@mui/material';

/** Neon green online badge dot. */
export const onlineBadgeSx: SxProps<Theme> = {
  '& .MuiBadge-dot': {
    bgcolor: '#00e676',
    width: 10,
    height: 10,
    borderRadius: '50%',
    border: '2px solid #12121f',
    boxShadow: '0 0 6px rgba(0,230,118,0.5)',
  },
};

/** Glassmorphism borderless input field. */
export const borderlessInputSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 3,
    bgcolor: 'rgba(255,255,255,0.04)',
    backdropFilter: 'blur(8px)',
    '& fieldset': { border: '1px solid rgba(255,255,255,0.06)' },
    '&:hover fieldset': { border: '1px solid rgba(124,77,255,0.3)' },
    '&.Mui-focused fieldset': { border: '1px solid rgba(124,77,255,0.5)' },
  },
};

/** Section label used in ContactInfo panels. */
export const sectionLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
};

/** Glassmorphism card style. */
export const glassCardSx: SxProps<Theme> = {
  background: 'rgba(18, 18, 31, 0.7)',
  backdropFilter: 'blur(20px)',
  border: '1px solid rgba(255,255,255,0.08)',
};
